// extracted by mini-css-extract-plugin
export default {"divBack":"Landing_divBack__S-cEJ","text":"Landing_text__mXrOv","btn":"Landing_btn__rMGOp"};